/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FileMetadataDto } from './FileMetadataDto';
import type { SheetDetailsDto } from './SheetDetailsDto';
export type SheetDto = {
    readonly id?: string;
    readonly createdDate?: string;
    readonly createdBy?: string;
    readonly modifiedDate?: string;
    readonly modifiedBy?: string;
    readonly version?: number;
    nameDe: string;
    nameEn: string;
    sheetNumber: string;
    active?: boolean;
    parentSheet?: string;
    operatingFluidTypes?: Array<string>;
    sheetType: SheetDto.sheetType;
    validityPeriod?: SheetDto.validityPeriod;
    files?: Array<FileMetadataDto>;
    thirdPartyCertificateRequired?: boolean;
    compatibleSheets?: Array<SheetDetailsDto>;
};
export namespace SheetDto {
    export enum sheetType {
        OVERVIEW = 'OVERVIEW',
        SPECIFICATION = 'SPECIFICATION',
    }
    export enum validityPeriod {
        FIVE_YEARS = 'FIVE_YEARS',
        TEN_YEARS = 'TEN_YEARS',
    }
}

